function PharmaciesListIcon() {
  return (
    <span className="anticon ant-menu-item-icon">
      <img
        src="/assets/images/Pharmacies_list .svg"
        alt="Pharmacies List"
        width="24"
        height="24"
      />
    </span>
  );
}

export default PharmaciesListIcon;
